module.exports = __webpack_public_path__ + "img/right_arrow.c2b61fc1.svg";